import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./pwa/browserOnline";
import "./index.css";
import App from "./App.tsx";
import { UPDATE_RELOAD_FLAG } from "./pwa/cachePolicy";

// After a new deploy, the service worker may replace its pre-cache while
// the page still holds old chunk references. A reload picks up the new
// HTML + new SW cache. A sessionStorage guard prevents infinite loops.
// If Vernieuwen already scheduled that reload, do not start a second one.
// See https://vite.dev/guide/build.html#load-error-handling
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  if (sessionStorage.getItem(UPDATE_RELOAD_FLAG) === "1") return;
  const key = "chunk-reload";
  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, "1");
  window.location.reload();
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
